import { localStorageJwtKey } from 'utils/constants';

const getJwt = (): string => localStorage.getItem(localStorageJwtKey) || '';

export const getHeaders = (additionalHeaders: ?{}) => ({
  Authorization: `Bearer ${getJwt()}`,
  ...additionalHeaders,
});
